// This file is automatically generated. Do not edit manually.

import { ShopOrder } from "src/api/generated/erp/db/types/tables/shopOrder";
import { ShopOrderUpdateService_UpdateRequest } from "src/api/generated/erp/production/service/shopOrder/shopOrderUpdateService";
import { ProductionLineView } from "src/api/generated/erp/db/types/tables/productionLineView";
import { PartView } from "src/api/generated/erp/db/types/tables/partView";
import { ShopOrderView } from "src/api/generated/erp/db/types/tables/shopOrderView";
import { Site } from "src/api/generated/erp/db/types/tables/site";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ShopOrderEditApi {
	export async function getFormData(args: {
		shopOrderId: number | null | undefined;
	}): Promise<ShopOrderEditApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderEdit/getFormData",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
			},
		});
		return response as ShopOrderEditApi_InitData;
	}

	export async function insert(args: {
		shopOrder: ShopOrder;
		partId: number;
		partConfigurationId?: number | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderEdit/insert",
			method: "POST",
			data: {
				shopOrder: args.shopOrder,
				partId: args.partId,
				partConfigurationId: args.partConfigurationId,
			},
		});
		return response as number;
	}

	export async function update(args: { shopOrder: ShopOrderUpdateService_UpdateRequest }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderEdit/update",
			method: "POST",
			data: {
				shopOrder: args.shopOrder,
			},
		});
		return response as void;
	}

	export async function updateShopOrderNote(args: {
		shopOrderId: number;
		note: string | null | undefined;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderEdit/updateShopOrderNote",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
				note: args.note,
			},
		});
		return response as void;
	}
}

export interface ShopOrderEditApi_InitData {
	allProductionLines: Array<ProductionLineView>;
	part: PartView | null | undefined;
	shopOrder: ShopOrderView | null | undefined;
	siteOptions: Array<Site>;
}
